import { Loading } from '@mostrans/web-components/components/base/Loading'
import React from 'react'
import { useRecoilValue } from 'recoil'
import { globalLoadingNonScreenAtom } from './globalStates'

function GlobalLoading() {
    const isLoading = useRecoilValue(globalLoadingNonScreenAtom)
    return (
        <React.Fragment>
            {isLoading && <Loading />}
        </React.Fragment>
    )
}

export default GlobalLoading